import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import {
  ProcessingJobAuthorization,
  BatchManagementAuthorization,
} from 'shell/authorizations/system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

const authsObject = Object.freeze({
  job: ProcessingJobAuthorization,
  batch: BatchManagementAuthorization,
  batchUploadFile: BatchManagementAuthorization,
  batchDownloadFile: BatchManagementAuthorization,
});

interface BatchManagementCollapseProps {
  onSubItemClick?: () => void;
  link: string;
}

const BatchManagementCollapse = ({
  onSubItemClick,
  link,
}: BatchManagementCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  const authorizations = useActionAuthorization(authsObject);

  return (
    <Fragment>
      {!authorizations.batch && !authorizations.job ? undefined : (
        <>
          <ListItem
            button
            key="Piattaforma Batch"
            onClick={() => {
              handleClick();
            }}
            sx={{ pl: 6 }}
            className={classes.colorItems}
          >
            <ListItemText className={classes.colorItems} primary="Piattaforma Batch" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {authorizations.batch ? (
                <Link
                  key={`${link}/gestione-batch`}
                  to={`${link}/gestione-batch`}
                  className="pmi-anchor"
                >
                  <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                    <ListItemText className={classes.colorItems} primary="Gestione Batch" />
                  </ListItem>
                </Link>
              ) : undefined}
              {authorizations.job ? (
                <Link
                  key={`${link}/elaborazione-job`}
                  to={`${link}/elaborazione-job`}
                  className="pmi-anchor"
                >
                  <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                    <ListItemText className={classes.colorItems} primary="Elaborazione Job" />
                  </ListItem>
                </Link>
              ) : undefined}
              {authorizations.batchUploadFile ? (
                <Link
                  key={`${link}/gestione-batch/gestione-file/upload`}
                  to={`${link}/gestione-batch/gestione-file/upload`}
                  className="pmi-anchor"
                >
                  <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                    <ListItemText className={classes.colorItems} primary="Gestione File - Upload" />
                  </ListItem>
                </Link>
              ) : undefined}
              {authorizations.batchDownloadFile ? (
                <Link
                  key={`${link}/gestione-batch/gestione-file/download`}
                  to={`${link}/gestione-batch/gestione-file/download`}
                  className="pmi-anchor"
                >
                  <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                    <ListItemText
                      className={classes.colorItems}
                      primary="Gestione File - Download"
                    />
                  </ListItem>
                </Link>
              ) : undefined}
            </List>
          </Collapse>
        </>
      )}
    </Fragment>
  );
};

BatchManagementCollapse.displayName = 'BatchManagement Collapse Item';

export default BatchManagementCollapse;
